
import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/psychology.png";
import PFAQ from "./PFAQ";
import PCurriculum from "./PCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import PPricing from "./PPricing";
import { Link } from "react-router-dom";
export default function PPage() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "Psychology",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Psychology",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Psychology",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Psychology</h1>
          <p className="program-detail-desc">
            Psychology studies how people think, feel, and act. It helps us understand emotions, relationships, stress, motivation, and decision-making. By learning how the mind works, psychology improves personal growth, communication, mental health, and how we live together.
          </p>
          <div className="program-detail-actions">
             <Link to="/register">
                        <button className="register-btn">Register Now</button>
                        </Link>
                        <Link to="/contact-us">
                        <button className="expert-btn">Talk To Expert</button>
                        </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
          Psychology is not about judging people—it’s about understanding them. At Acadme, you explore human behavior from the inside out: cognitive bias, emotional intelligence, personality, trauma, motivation, and social influence. You learn how environment shapes choices, how culture impacts belief, and how stress rewires the brain. Through case studies, listening skills, and role-based exercises, you practice empathy and observation in real contexts. The internship places you in real support environments, where you assist with assessments, communication, and guided interactions—handled ethically and responsibly. You learn how to help, not just analyze. Enroll with confidence and begin shaping a future where understanding people becomes your greatest strength.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <PCurriculum />
      <SkillPage />
      <Certificate />
      <PPricing />
      <PFAQ />
    </>
  );
}
